"use client";
import { Navigation, RotateCcw, X } from "lucide-react";
import { useEditorStore } from "@/stores/editorStore";

export function MovementInspector({ objectId }: { objectId: string }) {
  const walkToActorId = useEditorStore((state) => state.walkToActorId);
  const walkDuration = useEditorStore((state) => state.walkDuration);
  const stoppingDistance = useEditorStore((state) => state.stoppingDistance);
  const autoFaceDirection = useEditorStore((state) => state.autoFaceDirection);
  const startWalkTo = useEditorStore((state) => state.startWalkTo);
  const cancelWalkTo = useEditorStore((state) => state.cancelWalkTo);
  const setWalkDuration = useEditorStore((state) => state.setWalkDuration);
  const setStoppingDistance = useEditorStore((state) => state.setStoppingDistance);
  const setAutoFaceDirection = useEditorStore((state) => state.setAutoFaceDirection);
  const active = walkToActorId === objectId;
  return <section className="movement-inspector">
    <div className="animation-heading"><span>Character movement</span>{active && <span className="targeting-badge">Pick target</span>}</div>
    <div className="movement-settings">
      <label><span>Duration</span><div><input type="number" min="0.1" step="0.5" value={walkDuration} onChange={(event) => setWalkDuration(Number(event.target.value))} /><i>sec</i></div></label>
      <label><span>Stop distance</span><div><input type="number" min="0" step="0.1" value={stoppingDistance} onChange={(event) => setStoppingDistance(Number(event.target.value))} /><i>m</i></div></label>
    </div>
    <label className="auto-face-toggle"><input type="checkbox" checked={autoFaceDirection} onChange={(event) => setAutoFaceDirection(event.target.checked)} /><RotateCcw size={13} /><span>Auto face direction</span></label>
    <button className={`walk-to-button ${active ? "active" : ""}`} onClick={() => active ? cancelWalkTo() : startWalkTo(objectId)}>{active ? <X size={14} /> : <Navigation size={14} />}{active ? "Cancel Walk To" : "Walk To Object"}</button>
    <p className="movement-note">Creates synchronized Walk + Movement clips at the playhead.</p>
  </section>;
}
